import styled from 'styled-components';

import { TableWrap as DefaultTableWrap } from './loyalty-history.styled.default';

export * from './loyalty-history.styled.default';

export const TableWrap = styled(DefaultTableWrap)`
  ${Styles.mobile`
    thead {
      tr {
        td,
        th {
          &:first-child {
            text-align: left;
          }
        }
      }
    }
  `}
`;
